import { useEffect, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import { ServiceAndProducts } from "../../../ts/types";
import {
  getEventFullAddress,
  getFormattedDate,
  getFormattedTime,
} from "../../../utils";
import { RootState } from "../../../store";
import classes from "./EventDetailsCard.module.css";
import Card from "../../../components/Card/Card";
import eventCardImg from "../../../assets/icons/event-details-card.svg";
import timeIcon from "../../../assets/icons/time-white.svg";
import locationIcon from "../../../assets/icons/location-white.svg";
import { SelectedService } from "../../../ts/models/Event";

type Props = {
  actions?: JSX.Element;
  services: SelectedService[];
};

const EventDetailsCard: React.FC<Props> = ({ actions, services }) => {
  const { currEvent, servicesProductsOfCurrEvent, selectedDate } = useSelector(
    (state: RootState) => state.events
  );

  const [servicesAndProducts, setServicesAndProducts] = useState<
    ServiceAndProducts[]
  >([]);

  useEffect(() => {
    // Filtering Service And Selected Products from serviceId And product ids
    const servicesAndProducts: ServiceAndProducts[] = [];
    for (let i = 0; i < services?.length; i++) {
      const currServiceAndProductId = services[i];

      const { serviceId, productIds } = currServiceAndProductId;

      const serviceOfEvent = servicesProductsOfCurrEvent.find(
        (service) => service.service.id === serviceId
      );

      if (serviceOfEvent) {
        const service = serviceOfEvent.service;
        const products = serviceOfEvent.products.filter((product) =>
          productIds.includes(product.id)
        );
        servicesAndProducts.push({ service, products });
      }
    }
    setServicesAndProducts(servicesAndProducts);
  }, [services]);

  const { name, startTime, endTime } = currEvent;

  return (
    <Card className={classes.card}>
      <div>
        <div className={classes.detailsContainer}>
          <Card className={classes.imgContainer}>
            <img src={eventCardImg} alt='' />
          </Card>
          <div className={classes.left}>
            <div className={classes.eventName}>{name}</div>
            <div className={classes.dateContainer}>
              <div>
                <img src={timeIcon} alt='' />
                <div>{`${getFormattedDate(selectedDate)} | ${getFormattedTime(
                  startTime
                )} - ${getFormattedTime(endTime)}`}</div>
              </div>
              <div>
                <img src={locationIcon} alt='' />
                <div>{getEventFullAddress(currEvent)}</div>
              </div>
              <div className={classes.serviceContainer}>
                {servicesAndProducts.map((serviceAndProducts, idx) => {
                  const { service, products } = serviceAndProducts;
                  return (
                    <Fragment key={idx}>
                      <div>
                        <div className={classes.serviceName}>
                          {service.name}
                        </div>
                        <div className={classes.productContainer}>
                          {products.map((product, idx) => (
                            <div className={classes.productName} key={idx}>
                              {product.name}
                            </div>
                          ))}
                        </div>
                      </div>
                    </Fragment>
                  );
                })}
              </div>
            </div>
          </div>
          <div className={classes.right}>{actions}</div>
        </div>
      </div>
    </Card>
  );
};

export default EventDetailsCard;
